import { catchError } from 'rxjs/operators';
// Custom packages
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
import * as i3 from "ngx-cookie-service";
var PlatformNotesService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PlatformNotesService(apiService, helperService, cookieService) {
        this.apiService = apiService;
        this.helperService = helperService;
        this.cookieService = cookieService;
    }
    /**
     * Create a new company note
     *
     * @since 1.0.0
     *
     * @param companyId ID Company
     * @param data Company note data
     */
    PlatformNotesService.prototype.createCompanyNote = function (companyId, data) {
        return this.apiService.apiCall('POST', "platform-notes/company/" + companyId, data);
    };
    /**
     * Create a new property note
     *
     * @since 1.0.0
     *
     * @param propertyId ID Property
     * @param data Property note data
     */
    PlatformNotesService.prototype.createPropertyNote = function (propertyId, data) {
        return this.apiService.apiCall('POST', "platform-notes/property/" + propertyId, data);
    };
    /**
     * Get platform notes list for given query params
     *
     * @since 1.0.0
     *
     * @param [historical] Type of list
     * @param [companyId] Company Id
     * @param [propertyId] Property Id
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    PlatformNotesService.prototype.getList = function (historical, companyId, propertyId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (historical) {
            search['historical'] = true;
        }
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        if (propertyId !== '') {
            return this.apiService.apiCall('GET', "platform-notes/property/" + propertyId, params);
        }
        return this.apiService.apiCall('GET', "platform-notes/company/" + companyId, params);
    };
    /**
     * Get all company notes with properties
     */
    PlatformNotesService.prototype.getCompanyProperty = function (companyId, propertyId) {
        return this.apiService.apiCall('GET', "platform-notes/company/" + companyId + "/" + propertyId, {});
    };
    /**
     * Get an exportation file of all platform note of company
     *
     * @since 1.0.0
     */
    PlatformNotesService.prototype.getCompanyExport = function (companyId, historical) {
        var _this = this;
        return this.apiService.apiCall('GET', "platform-notes/company-export/" + companyId, { historical: historical }, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all platform note of property
     *
     * @since 1.0.0
     */
    PlatformNotesService.prototype.getPropertyExport = function (propertyId, historical) {
        var _this = this;
        return this.apiService.apiCall('GET', "platform-notes/property-export/" + propertyId, { historical: historical }, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get notes of company
     */
    PlatformNotesService.prototype.getCompany = function (companyId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "platform-notes/company/" + companyId, params);
    };
    /**
     * Get notes of company
     */
    PlatformNotesService.prototype.getCompanyWithProperties = function (companyId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "platform-notes/company-with-properties/" + companyId, params);
    };
    /**
     * Get notes of property
     */
    PlatformNotesService.prototype.getProperty = function (propertyId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "platform-notes/property/" + propertyId, params);
    };
    /**
     * Get notes of all property balances
     */
    PlatformNotesService.prototype.getPropertyBalancesNotes = function (propertyId) {
        return this.apiService.apiCall('GET', "platform-notes/property-balances/" + propertyId, {});
    };
    /**
     * Get notes of all company balances
     */
    PlatformNotesService.prototype.getCompanyBalancesNotes = function (companyId) {
        return this.apiService.apiCall('GET', "platform-notes/company-balances/" + companyId, {});
    };
    /**
     * Get creators list
     */
    PlatformNotesService.prototype.getCreators = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "platform-notes/creators", params);
    };
    /**
     * Update fileds of note
     *
     * @since 1.0.0
     *
     * @param noteId ID of note
     * @param data fileds of note
     */
    PlatformNotesService.prototype.updateNote = function (noteId, data) {
        return this.apiService.apiCall('PATCH', "platform-notes/" + noteId, data);
    };
    /**
     * Deactivate note
     *
     * @since 1.0.0
     *
     * @param noteId ID of note
     */
    PlatformNotesService.prototype.deactivateNote = function (noteId) {
        return this.apiService.apiCall('PATCH', "platform-notes/" + noteId + "/deactivate", {});
    };
    /**
     * Move the property notes to another company
     *
     * @since 1.0.0
     *
     * @param noteId ID of note
     */
    PlatformNotesService.prototype.movePropertyCompany = function (propertyId, companyId, notesId) {
        var data = {
            propertyId: propertyId,
            companyId: companyId,
            notesId: notesId
        };
        return this.apiService.apiCall('PATCH', "platform-notes/move-property-company", data);
    };
    /**
     * Delete the property notes from company
     *
     * @since 1.0.0
     *
     * @param noteId ID of note
     */
    PlatformNotesService.prototype.deletePropertyCompany = function (propertyId, companyId) {
        var data = {
            propertyId: propertyId,
            companyId: companyId
        };
        return this.apiService.apiCall('PATCH', "platform-notes/delete-property-company", data);
    };
    /**
     * Update notes of property reactivated
     *
     * @since 1.0.0
     *
     * @param noteId ID of note
     */
    PlatformNotesService.prototype.propertyReactivated = function (propertyId, notesId) {
        var data = {
            notesId: notesId
        };
        return this.apiService.apiCall('PATCH', "platform-notes/property-reactivated/" + propertyId, data);
    };
    /**
     * Delete note
     *
     * @since 1.0.0
     *
     * @param noteId ID of note
     */
    PlatformNotesService.prototype.deleteNote = function (noteId) {
        return this.apiService.apiCall('DELETE', "platform-notes/" + noteId);
    };
    PlatformNotesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PlatformNotesService_Factory() { return new PlatformNotesService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService), i0.ɵɵinject(i3.CookieService)); }, token: PlatformNotesService, providedIn: "root" });
    return PlatformNotesService;
}());
export { PlatformNotesService };
